
import { useEffect } from "react";
import { userManager } from "./Auth";
import { useDispatch } from "react-redux";
import { setUser } from "../actions/actionsBase";
import { actionTypes } from "../types/enums";

export default function Callback() {
  const dispatch = useDispatch();

  useEffect(() => {
    userManager.signinRedirectCallback().then((user) => {
      if (user) {
        // ✅ store full user object
        dispatch(setUser(actionTypes.SET_USER, user));

        // ✅ redirect after login
        window.location.href = "/";
      }
    }).catch((err) => {
      console.error("OIDC callback error", err);
    });
  }, [dispatch]);

  return <div>Logging in...</div>;
}
